import Vue from 'vue'
import VueI18n from 'vue-i18n'
import fr_fr from '@/languages/fr_fr'
import en_us from '@/languages/en_us'
import AppHelper from "../helper";

Vue.use(VueI18n);

var userLang = navigator.language || navigator.userLanguage;
userLang = userLang.toLowerCase().split('-')[0];

var messages = {
    'en': en_us,
    'fr': fr_fr
};

// Sets default language
if(AppHelper.empty(messages[userLang])){
    userLang = 'en'
}

const i18n = new VueI18n({
    locale: userLang,
    messages: messages
})

export default i18n


// WEBPACK FOOTER //
// ./src/languages/index.js